<script lang="ts" setup>
import type { UspRecord } from "~~/server/graphql/datocms/generated";
import { stripStega } from "vue-datocms";

defineProps<{ data: UspRecord[] }>();
</script>

<template>
  <div class="grid gap-8 lg:grid-cols-3 lg:gap-6">
    <div v-for="usp in data" :key="usp.id">
      <NuxtLinkLocale :to="`/${usp.link?.slug}`">
        <div class="flex flex-col items-center">
          <div>
            <IconUspWrapper :name="stripStega(usp.icon)" />
          </div>
          <b>{{ usp.title }}</b>
          <p>
            {{ usp.shortText }}
          </p>
        </div>
      </NuxtLinkLocale>
    </div>
  </div>
</template>

<style>

</style>
